import { FetchingProjectValueActionType, PersistProjectValueActionType } from 'features/Persist/actionTypes';
import { PersistProjectValueReducer } from 'features/Persist/reducerTypes';
import { ScheduleConfigurationResponse } from 'services/tenantManagementService';
import { SCHEDULE_CONFIGURATION_FETCHING, SCHEDULE_CONFIGURATION_SET } from './action';

export const scheduleConfigurationReducer = (state = new PersistProjectValueReducer<ScheduleConfigurationResponse>(), action: PersistProjectValueActionType<ScheduleConfigurationResponse> | FetchingProjectValueActionType): PersistProjectValueReducer<ScheduleConfigurationResponse> => {
	switch (action.type) {
		case SCHEDULE_CONFIGURATION_FETCHING: {
			const { fetching, projectId } = action as FetchingProjectValueActionType;

			return {
				projectMap: {
					...state.projectMap,
					[projectId]: {
						isInitialized: state.projectMap[projectId]?.isInitialized || false,
						fetching,
						value: state.projectMap[projectId]?.value || new ScheduleConfigurationResponse()
					}
				}
			}
		}
		case SCHEDULE_CONFIGURATION_SET: {
			const { value, projectId } = action as PersistProjectValueActionType<ScheduleConfigurationResponse>;

			const projectMap = {
				...state.projectMap,
				[projectId]: {
					isInitialized: true,
					fetching: false,
					value
				}
			}

			return {
				projectMap
			}
		}
		default:
			return state;
	}
}
